export default __webpack_public_path__ + "static/media/EcoLock.99f776ea.jpg";